import * as angular from 'angular';
import * as _ from 'lodash';
import ComponentController from '../../../common/components/component-controller';
const templateUrl = require('./subscriptions.html');

class SubscriptionsController extends ComponentController {
  subscriptions: any[];
  canCreate: boolean;
  currentSite: any;

  constructor(private $state: any, private SubscriptionService: any, private AuthService: any) {
    super();
  }

  $onInit() {
    this.canCreate = this.AuthService.hasPermission('Subscription', 'create');
  }
}

angular.module('ciApp').component('epx.subscriptions', {
  templateUrl: templateUrl,
  bindings: {
    subscriptions: '<',
    currentSite: '<'
  },
  controller: ['$state', 'SubscriptionService', 'AuthService', SubscriptionsController]
});



// WEBPACK FOOTER //
// ./app/epx/subscriptions/subscriptions.component.ts